<template>
    <div class="row">
        <div class="col-12" v-if="!isExtendedSuccessfully">
            <form @submit.prevent="submitPayment">
                <div class="row justify-content-center align-items-center">
                    <div class="col-12 mt-5">
                        <h4 class="text-uppercase pb-3">{{$ml.get('payment_options')}}</h4>
                    </div>
                    <div class="col-12">
                        <PaymentOptions />
                        <div class="row justify-content-center align-items-center pt-4">
                            <div class="col-7 text-center">
                                <font-awesome-icon icon="spinner" size="2x" class="fa-spin" v-if="loading"/>
                                <button type="submit" class="btn btn-lg btn-warning form-control text-uppercase" v-else>
                                    {{$ml.get('extend')}}
                                </button>
                            </div>
                        </div>
                        <div class="row justify-content-center align-items-center"
                             v-if="errorMessages.generalError.length">
                            <div class="col-5 form-group">
                                <small class="form-text text-danger">
                                    {{$ml.get('general_error_msg')}}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-12 align-items-center text-center" v-else>
            <h5 class="text-uppercase text-center pb-3">{{$ml.get('current_plan_is_extended')}}</h5>
            <button type="button" class="btn btn-outline-dark qf-fs-90 text-uppercase"
                    @click="closeExtendPlan">
                {{$ml.get('Close')}}
            </button>
        </div>
    </div>

</template>

<script>
    import PaymentOptions from "../../common/PaymentOptions";
    export default  {
        name: 'ExtendPlan',
        components: {PaymentOptions},
        data() {
            return {
                loggedUser: {
                    first_name: '',
                    last_name: '',
                    card_holder: ''
                },
                errorMessages: {
                    first_name: '',
                    last_name: '',
                    card_holder: '',
                    generalError: ''
                },
                loading: false,
                isExtendedSuccessfully: false
            }
        },
        mounted() {
            this.loggedUser.card_holder = `${this.$store.state.loggedUser.first_name} ${this.$store.state.loggedUser.last_name}`;
        },
        methods: {
            submitPayment() {
                if (!this.loading) {
                    this.errorMessages = {
                        first_name: '',
                        last_name: '',
                        card_holder: '',
                        generalError: ''
                    };

                    this.$validator.validateAll().then((result) => {

                        // TODO: finish the validation when payment system is integrated
                        // and link and send payment information to the backend

                        this.loading = true;
                        this.$store.dispatch('extend').then(response => {
                            this.$emit('updateUserData', response);
                            this.loading = false;
                            this.isExtendedSuccessfully = true;
                        }).catch(error => {
                            if (error.status === 400) {
                                error.data.forEach(obj => {
                                    this.errorMessages[obj.property_path] = obj.message;
                                });
                            } else {
                                this.errorMessages.generalError = 'error';
                            }
                            this.loading = false;
                        });
                    });
                }
            },
            closeExtendPlan() {
                this.$emit('closeExtendPlan');
                this.isExtendedSuccessfully = false;
            }
        }
    }
</script>

<style scoped>

</style>